import { Body, Controller, Post, UploadedFiles, UseInterceptors } from '@nestjs/common';
import { ApiTags, ApiConsumes, ApiBody, ApiOperation, ApiResponse } from '@nestjs/swagger';
import { QcClearanceInfoService } from './qc-clearance-info.service';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { FilesInterceptor } from '@nestjs/platform-express';
import { diskStorage } from "multer";
import { join, extname } from 'path';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { QcClearanceDTO } from '@gtpl/shared-models/planning';
@Controller('qc-clearance-info')
@ApiTags('qc-clearance-info')
export class QcClearanceInfoController {

    constructor(
        private qcClearanceInfoService: QcClearanceInfoService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ) { }

    @Post('createClearance')
    @ApiOperation({ summary: 'Create QC Clearance with file upload and references' })
    @ApiConsumes('multipart/form-data')
    @ApiBody({
        schema: {
            type: 'object',
            properties: {
                clearanceData: {
                    type: 'string',
                    description: 'QC Clearance data as JSON string',
                },
                fileReferences: {
                    type: 'string',
                    description: 'JSON string array mapping files to ReferenceFeatures. Example: [{"reference": "CHEMICAL", "fileName": "file1.pdf"}]',
                },
                filesData: {
                    type: 'array',
                    items: {
                        type: 'string',
                        format: 'binary',
                    },
                    description: 'Upload multiple files (any format)',
                },
            },
        },
    })
    @ApiResponse({ status: 201, description: 'QC Clearance created successfully' })
    @ApiResponse({ status: 400, description: 'Invalid request' })
    @UseInterceptors(FilesInterceptor('filesData', 200, {
    storage: diskStorage({
        destination: (req, file, cb) => {
        const uploadPath = join(__dirname, '../../../../upload-files/qc-clearance-files'); 
        console.log(`Uploading file to: ${uploadPath}`);

        cb(null, uploadPath);
        },
        filename: (req, file, callback) => {
        const name = file.originalname.split('.')[0];
        const fileExtName = extname(file.originalname);
        const randomName = Array(4)
            .fill(null)
            .map(() => Math.round(Math.random() * 16).toString(16))
            .join('');
        callback(null, `${name}-${randomName}${fileExtName}`);
        },
    }),
    limits: { fileSize: 50 * 1024 * 1024 },
    }))
    async createClearance(@UploadedFiles() filesData: any[], @Body() req: any):Promise<CommonResponse> {
        try {
            const clearanceData = JSON.parse(req.clearanceData);
            const fileReferences = JSON.parse(req.fileReferences);

            const mappedFiles = filesData.map(file => {
                const ref = fileReferences.find(ref => ref.fileName === file.originalname);
                return { file, reference: ref ? ref.reference : null};
            });

            return await this.qcClearanceInfoService.createClearance(clearanceData, mappedFiles);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('getFileDetailsById')
    @ApiBody({type: QcClearanceDTO})
    async getFileDetailsById(@Body() req: QcClearanceDTO): Promise<CommonResponse>{
        try{
            return await this.qcClearanceInfoService.getFileDetailsById(req)
        }catch(err){
            return this.applicationExceptionHandler.returnException(CommonResponse, err)
        }
    }
}
